import * as React from 'react'
import { useAidaOverlayStore } from '../stores/overlay-store'
import type { AidaPresentationMode } from '../stores/overlay-store'

export type AidaChatPresentation = 'fullscreen' | 'dock' | 'float'

export const AidaChatPresentationContext = React.createContext<AidaChatPresentation>('fullscreen')

export function chatPresentationForOverlayMode(mode: AidaPresentationMode): AidaChatPresentation {
  if (mode === 'fullscreen') {
    return 'fullscreen'
  }
  if (mode === 'dock') {
    return 'dock'
  }
  return 'float'
}

export function useAidaChatPresentation() {
  return React.useContext(AidaChatPresentationContext)
}

export function resolveAidaChatPresentation(
  open: boolean,
  overlayMode: AidaPresentationMode,
  contextPresentation: AidaChatPresentation,
): AidaChatPresentation {
  if (open && overlayMode !== 'fullscreen') {
    return chatPresentationForOverlayMode(overlayMode)
  }
  return contextPresentation
}

export function useResolvedAidaChatPresentation() {
  const open = useAidaOverlayStore(state => state.open)
  const overlayMode = useAidaOverlayStore(state => state.mode)
  const contextPresentation = useAidaChatPresentation()
  return resolveAidaChatPresentation(open, overlayMode, contextPresentation)
}
